import React from 'react'

const CoreComponent22 = ({technologiesstack}) => {
  return (
    <div>
        <div className="row mt-4">
          {technologiesstack.map((val,i)=>(
            <div key={i}f className="col-lg-4 col-md-6 mb-4 text-center">
              <div className="border rounded-4 p-3 invest-box bg-light h-100 " style={{marginBottom:30}}>
                <h3 className='h3-heading lh-base '>{val.title}</h3>
                <img src={val.icon} alt="" className="my-3 icon-logo" />
                <p className='h3-para lh-base'>{val.desc}</p>
              </div>
            </div>
          ))}
        </div>
    </div>
  )
}

export default CoreComponent22